(function() { window.GUID_6baaa13a_48b6_46f4_902d_f2965ac8b321 = { getGuid: function() { return "6baaa13a-48b6-46f4-902d-f2965ac8b321"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class TextBox extends Controls.ControlValueBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
                let me = this;
                if (this.$Control.is(':input')) {
                    this.$input = this.$Control; //Cette situation arrive par exemple dans la scoresheet ou le textbox est plus épuré
                }
                else {
                    this.$input = this.$Control.find('input:not(".original-value")');
                }
                if (params[1] && params[2] == "True") {
                    const txt = document.createElement("textarea");
                    txt.innerHTML = params[1];
                    this.$input.val(txt.value);
                }
            }
            OnDispose() {
                this.$Control.off('input.' + this.UniqueNamespace);
                this.$Control.remove();
            }
            OnBindEvents() {
                let me = this;
                this.$Control.offon('input.' + this.UniqueNamespace, function (e) {
                    if (e.keyCode == 9 || (e.keyCode > 36 && e.keyCode < 41)) {
                        return;
                    }
                    me.Trigger(TextBox.EventNames.TextChanged, { jqueryEventObject: e, data: me.val() });
                }).offon('keydown.' + this.UniqueNamespace, function (e) {
                    let key = CS.GetKeyPressed(e);
                    if (key == CS.Enums.KeyCode.Enter) {
                        me.Trigger(TextBox.EventNames.EnterKeyPressed, { jqueryEventObject: e, data: me.val() });
                    }
                });
            }
            GetValue() {
                return this.$input.val();
            }
            SetValue(value, triggerTextChangedEvent) {
                //NUISAIT, CEST POURUQUOI JE LAI COMMENTÉ ET JE TROUVAIS PAS NULL PART QUE CA SERVAIT
                //if (this.$input.is(':focus')) {
                //    return;
                //}
                this.$input.val(value);
                if (triggerTextChangedEvent)
                    this.Trigger(TextBox.EventNames.TextChanged, { jqueryEventObject: null, data: this.$input.val() });
            }
        }
        Controls.TextBox = TextBox;
        (function (TextBox) {
            class Events extends Controls.ControlValueBase.Events {
                static TextChanged(param) {
                    Controls.RegisterEvent(TextBox, EventNames.TextChanged, param);
                }
                static EnterKeyPressed(param) {
                    Controls.RegisterEvent(TextBox, EventNames.EnterKeyPressed, param);
                }
            }
            TextBox.Events = Events;
            class EventNames extends Controls.ControlValueBase.EventNames {
            }
            EventNames.TextChanged = "textbox-textchanged";
            EventNames.EnterKeyPressed = "textbox-enterkeypressed";
            TextBox.EventNames = EventNames;
        })(TextBox = Controls.TextBox || (Controls.TextBox = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=textbox.js.map
